<script>
    export default {
        data() {
            return {
                isVisible: false
            }
        }
    }
</script>
